<template>
  <div>
    <header id="header">
      <div class="lke-header-top">
        <div>
          <img src="../assets/xueyuanLogo.png" alt="" />
        </div>
      </div>
      <div class="lke-header">
        <div class="lke-header-in">
          <router-link
            :to="'/' + tab.router"
            style="text-decoration: none; color: #333"
            class="lke-header-tab"
            :class="{ active: tabsIndex == index }"
            v-for="(tab, index) in tabs"
            :key="index"
          >
            {{ tab.name }}
          </router-link>
        </div>
      </div>
    </header>
    <router-view :style="{ minHeight: MidHeight + 'px' }" />
    <div class="lke-fot" id="bottom">
      <div class="lke-fot-in">
        <div class="lke-fot-tab">
          <div class="lke-fot-tab-in" v-if="link.length > 0">
            <span>常用链接</span>
            <a :href=" link[0] ? link[0].url : ''">{{ link[0] ? link[0].title : ''}}</a>
            <a :href=" link[1] ? link[1].url : ''">{{ link[1] ? link[1].title : ''}}</a>
            <a :href=" link[2] ? link[2].url : ''">{{ link[2] ? link[2].title : ''}}</a>
          </div>
        </div>
        <div class="lke-fot-tab">
          <div class="lke-fot-tab-in" v-if="link.length > 3">
            <span>常用链接</span>
            <a :href=" link[3] ? link[3].url : ''">{{ link[3] ? link[3].title : ''}}</a>
            <a :href=" link[4] ? link[4].url : ''">{{ link[4] ? link[4].title : ''}}</a>
            <a :href=" link[5] ? link[5].url : ''">{{ link[5] ? link[5].title : ''}}</a>
          </div>
        </div>
        <div class="lke-fot-tab">
          <div class="lke-fot-tab-in"  v-if="link.length > 6">
            <span>常用链接</span>
            <a :href=" link[6] ? link[6].url : ''">{{ link[6] ? link[6].title : ''}}</a>
            <a :href=" link[7] ? link[7].url : ''">{{ link[7] ? link[7].title : ''}}</a>
            <a :href=" link[8] ? link[8].url : ''">{{ link[8] ? link[8].title : ''}}</a>
          </div>
        </div>
        <div class="lke-fot-tab">
          <img v-if="form.qiniuCdn && form.erCode" class="lke-imgal" :src="form.qiniuCdn + form.erCode" alt="">
        </div>
      </div>
      <div class="lke-for-in2">
        <p>备案号： {{form.beian}}</p>
        <p>{{form.zhuti}}版权所有</p>
      </div>
    </div>
  </div>
</template>

<script>
import $api from "@/modules/apicloud";
import { gethomeinfo } from "@/api/index";
export default {
  props: {},
  data() {
    return {
      form: {},
      link:[],
      MidHeight: 100,
      headerHeight: 0,
      bottomHeight: 0,
      tabs: [
        { name: "首 页", router: "" },
        { name: "我的课程", router: "wdkc" },
        { name: "我的考试", router: "wdks" },
        { name: "实训平台", router: "sxpt" },
        { name: "联系我们", router: "lxwm" },
      ],
    };
  },
  computed: {
    tabsIndex() {
      return this.$store.state.tabsIndex;
    },

    userInfo() {
      return this.$store.state.userInfo;
    },

    home() {
      return this.$store.state.home;
    },
  },
  watch: {
    "$route.path": {
      deep: true,
      handler: function (val, oldVal) {
        
      },
    },
    home: {
      deep: true,
      handler(val) {
        if (val) {
          this.applyHomeData(val);
        }
      },
    },
  },
  created() {
    this.gethomeinfo()
  },
  
  mounted() {
    
    let header = $api.dom("#header");
    this.headerHeight = header.offsetHeight;
    let bottom = $api.dom("#bottom");
    this.bottomHeight = bottom.offsetHeight;
    this.MidHeight = window.innerHeight - this.headerHeight - this.bottomHeight;
  },
  watch: {},
  methods: {
    applyHomeData(homeData) {
      const safeHome = homeData || {};
      this.form = safeHome.system || {};
      this.link = Array.isArray(safeHome.link) ? safeHome.link : [];
    },
    gethomeinfo() {
      if (this.home) {
        this.applyHomeData(this.home);
      } else {
        gethomeinfo().then((response) => {
          this.$store.commit("home", response);
          this.applyHomeData(response);
        });
      }
    },
    // changeTab(index) {
    //     this.$store.commit("tabsIndex", index);
    // },
  },
  components: {},
};
</script>

<style scoped>
header {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.lke-header-top {
  width: 1024px;
  height: 110px;
  margin: 0 auto;
  background: url("../assets/xueyuan.png") no-repeat right center;
  display: flex;
  justify-content: center;
}
.lke-header-top > div {
  height: 100%;
  width: 1024px;
  display: flex;
  align-items: center;
}
.lke-header {
  min-width: 1024px;
  background: #bfbfbf;
}
.lke-header-in {
  width: 924px;
  padding: 0 50px;
  display: flex;
  margin: 0 auto;
  align-items: center;
}
.lke-header-tab {
  width: 100%;
  font-size: 18px;
  padding: 15px 0;
  color: #545454;
  cursor: pointer;
  text-align: center;
}
.lke-header-tab:hover {
  background: #2890f4;
}
.lke-header-tab.active {
  background: #2890f4;
  color: #fff !important;
}
.lke-fot {
  min-width: 1024px;
  padding: 50px 0;
  background: #404040;
}
.lke-fot-in {
  width: 1024px;
  margin: 0 auto;
  display: flex;
}
.lke-fot-tab {
  width: calc(100% / 4);
  padding: 0;
  display: flex;
  justify-content: center;
}
.lke-fot-tab-in {
  display: flex;
  flex-direction: column;
}
.lke-for-in2{
  width: 1024px;
  margin: 0 auto;
}
.lke-for-in2 > p{
  padding-left: 50px;
  padding-bottom: 5px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.lke-fot-tab-in > span {
  padding-bottom: 15px;
  font-size: 16px;
  color: #fff;
}
.lke-fot-tab-in > a {
  padding-bottom: 5px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.lke-fot-tab-in > a:hover {
  color: #753582;
}
.lke-route {
  width: 1024px;
  margin: 0 auto;
}
.lke-imgal{
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/index.vue